import {InspectedFirmPage} from 'modules/InspectedFirm';

export default InspectedFirmPage;
